import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import i18n from './i18n'
import 'virtual:uno.css'
// import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue'
// import { useAuthStore } from '@/stores/auth'
// import { useCustomerStore } from '@/stores/customer'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
// app.use(ElementPlus, {
//   locale: zhCn,
// })
// 配置 Element Plus 的语言
app.config.globalProperties.$ELEMENT = {
  locale: zhCn,
}
// Initialize auth check
// const authStore = useAuthStore()
// if (authStore.isTokenExpired) {
//   authStore.clearAuth()
// }

// Initialize customer store from localStorage
// const customerStore = useCustomerStore()
// customerStore.initializeFromStorage()

app.mount('#app')
